<ng-container>
  <div class="log-metadata">
    <div class="log-metadata-time">{{log.eventCreated}}</div>
    <div class="v-center">
      <div class="log-metadata-category">
        <div>{{ capitalizeFirstLetters(log.category) }}</div>
      </div>
      <div class="log-metadata-category">
        <div class="badge automation-background" *ngIf="isAutomationRule()" style="margin-left: 4px">Automation Action</div>
      </div>
    </div>
    <div class="log-metadata-category">
      <ng-container *ngFor="let list of log.eventCodeList">
        <div class="badge xml-code">{{ list.code }}</div>
      </ng-container>
    </div>
    <div class="log-metadata-device"> 
      <div class="log-metadata-device-zone" *ngIf="log.zone_number">{{log.zone_number}}</div>
      <div class="log-metadata-device-name" [class.no-name]="!log.name">{{log.name ?? 'No Name'}}</div>
    </div>
    <div class="log-metadata-other" *ngIf="log.trigger.toLowerCase() != 'procedure'">{{log.trigger}} - {{log.status_text}}</div>
    <div class="event-log-metadata-other" *ngIf="log.trigger.toLowerCase() === 'procedure'">{{ procedureName ?? ' No Procedure Name'}}</div>
    <div class="event-log-metadata-other" *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
  </div>
</ng-container>